import React from 'react';
import SalesListing from '../admin/SalesListing';
import { useAuth } from '../../context/AuthContext';

/**
 * Thin wrapper around admin SalesListing — restricts view to the current agent's
 * own cases only. Used for the /agent/sales route.
 */
export default function AgentSales() {
  const { user } = useAuth();
  return (
    <SalesListing
      restrictToUserId={user?.id}
      pageTitle="My Sales"
      pageSubtitle="All cases you've submitted"
    />
  );
}
